import { useEffect, useState } from "react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import RoomTable from "@/components/backoffice/table-floor/RoomTable";
import FloorTable from "@/components/backoffice/table-floor/FloorTable";
import API from "@/api/lib/api";

function TableFloorPlan() {  
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [floorsResponse, roomsResponse] = await Promise.all([
        API.get(`restaurant/${user?.restaurant_id}/floors`),
        API.get(`restaurant/${user?.restaurant_id}/rooms`),
      ]);

      setData({
        floors: floorsResponse.data,
        rooms: roomsResponse.data,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.restaurant_id) fetchData();
  }, [user?.restaurant_id]);

  if (loading) return <TableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "Floor & Room Management" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Settings", path: "/backoffice/menu/drinks" },
        { name: "Table Settings", path: "/backoffice/table-floor-plan" },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-5">
        {/* <div className="flex justify-end items-start md:items-center md:flex-row flex-col w-full">
          
        </div> */}
        <Tabs valueKey="table-floor" className="bg-transparent relative" defaultValue="room">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            
            <TabsTrigger value="floor">Floor</TabsTrigger>
            <TabsTrigger className="bg-transparent" value="room">Room</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <RoomTable data={data?.rooms} floors={data?.floors} onRefresh={fetchData} />
          <FloorTable data={data?.floors} onRefresh={fetchData} />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default TableFloorPlan;
